import axios from 'axios';

// Tarjetas guardadas (PanToken de PowerTranz). Se autentica con la cookie de sesion del cliente; el backend toma
// el cliente del JWT, nunca de estos parametros. El PanToken jamas viaja al navegador: solo id, marca y fecha.
const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
    withCredentials: true
});

export class SavedPaymentMethodsFetchAPI {

    // machineId (opcional): limita a las tarjetas del merchant de PowerTranz de esa caja
    static async list(machineId) {
        const res = await server(`/saved-payment-methods`, {
            method: "get",
            params: machineId ? { machine_id: machineId } : undefined,
        });
        return res
    }

    static async remove(id) {
        const res = await server(`/saved-payment-methods/${encodeURIComponent(id)}`, {
            method: "delete",
        });
        return res
    }

    static async setDefault(id) {
        const res = await server(`/saved-payment-methods/${encodeURIComponent(id)}/default`, {
            method: "patch",
        });
        return res
    }
}
